import { Checkbox, FormControl, FormControlLabel } from "@mui/material";
import { useField } from "formik";
import { at } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./CsplTermsAndConditions.module.css";
import { makeStyles } from "@material-ui/core/styles";
import Link from '@mui/material/Link';
import { style } from "@mui/system";

const checkBtn = makeStyles(() => ({
  root: {
    '& .MuiCheckbox-root':{
      paddingRight: "5px",
      paddingLeft:"0px",
      marginLeft: "11px",
      backgroundColor: "transparent",
     
    },
    '& .MuiSvgIcon-root':{
      width:"16px",
      height:"17px",
    }
  },
}));
export default function CsplTermsAndConditions(props) {
  const { label, ...rest } = props;
  const [field, meta, helper] = useField(props);
  const { setValue } = helper;
  const { t } = useTranslation("common");
  const classes = checkBtn();
  function _renderHelperText() {
    const [touched, error] = at(meta, "touched", "error");
    if (touched && error) {
      return <span className="cspl_error">{error}</span>;
    }
  }

  function _onChange(e) {
    setValue(e.target.checked);
  }

  return (
    <FormControl {...rest} sx={{
      '& .MuiFormControlLabel-root':{
       marginBottom:"-5px",
       position: "inherit !important",
       zIndex: "0 !important"
         }
       }}>
      <FormControlLabel
        value={field.value}
        checked={field.value}
        control={<Checkbox {...field} onChange={_onChange} />}
     /*    className={ props.noScroll ? styles.pureblack : false } */
        className={`${classes.root} ${props.darkTheme ? styles.darkTheme_label : false}`}
        label={
          <>
            {(props.onlinkclick == null || props.onlinkclick == undefined) && t(label)}
            {props.onlinkclick && label &&  <Link
            className="checkBoxLinks"
              onClick={(e) => {    
                e.preventDefault();            
                props.onlinkclick(e)
              }}
             
            >
              
                {t(label)}  
            </Link>
            }
           
          </>
        }   
      />
      {!props.showlinktext && (
        <div className={ props.darkTheme ?  styles.darkTheme_termsCond : styles.termsCond } >
          <p className={ props.noScroll ? styles.noScroll_termsandConditionsContent : styles.termsandConditionsContent} >
            {props.description}
          </p>
        </div>
      )}
      {_renderHelperText()}
    </FormControl>
  );
}
